import Container from "react-bootstrap/Container";
import {Link, useRouteError} from "react-router-dom";

export default function RootErrorPage() {
    const error = useRouteError();

    return (
        <Container fluid className={"vh-100 px-0 g-3 d-flex flex-column align-content-center justify-content-center"}>
            <Container className={"bg-success d-flex rounded-3 flex-column text-light"}>
                <h1 className={"mx-auto my-3"}>Oops!</h1>
                <p className={"mx-auto"}>Sorry, an unexpected error has occurred.</p>
                <p>
                    <i className="">{error.statusText || error.message}</i>
                </p>
                <p><Link to="/" className="text-light">Return Home</Link> </p>
            </Container>
        </Container>
    );
}